<!--
* UIID: UI-Caas-PTN-110
* UI Name: Parnert List
* Modify Date: 2020/06/17
-->
<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12" md="10">
        <v-toolbar-title class="font-bold">{{$t("lbl.partners.page_header")}}</v-toolbar-title>
      </v-col>
      <v-col cols="12" md="2" class="text-right pa-0 pr-3">
        <v-btn text icon @click="change2List()" height=30 class="list-btn-bg-color mr-1">
          <v-icon small :color="this.listColor">
            fa fa-list
          </v-icon>
        </v-btn>
        <v-btn text icon @click="change2Grid($event)" height=30 class="list-btn-bg-color">
          <v-icon small :color="this.gridColor">
            fa fa-th
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <component :is="selectedComponent" :items="listData"></component>
  </div>
</template>

<script>
import partnerCardList from '@/vue-caas/views/partner/PartnerCardList.vue'
import partnerTableList from '@/vue-caas/views/partner/PartnerTableList.vue'

export default {
  components: {
    partnerCardList,
    partnerTableList,
  },

  data(){
    return{
    listData: Array,
    gridView: true,
    listColor:'secondary',
    gridColor:'secondary',
    listView: false,
    selectedComponent: '',
  }},

  computed: {
    isGridView() {
      return this.gridView?"":"d-none";
    },

    isListView() {
      return this.listView?"":"d-none";
    }
  },

  methods: {
    change2List() {
      const params = {};
      this.listColor="primary";
      this.gridColor="secondary";
      // 2021.5.17 203728 SPKA-107 Change get partner list
      this.$store.dispatch('getPartnerListByCompany', params).then(() => {
        this.listData = this.$store.getters.partnerList;
        this.selectedComponent = 'partnerTableList';
      });
    },

    change2Grid() {
      const params = {};
      this.listColor="secondary";
      this.gridColor="primary";
      // 2021.5.17 203728 SPKA-107 Change get partner list
      this.$store.dispatch('getPartnerListByCompany', params).then(() => {
        // alert('hash: ' + this.$store.getters['membership/hash']);
        this.listData = this.$store.getters.partnerList;
        this.selectedComponent = 'partnerCardList';
      });
    },
  },

  created() {
    // 2021.3.25 203728 SPKA-57 issue 24
    this.change2List();
  },
  
}
</script>
<style scoped>
  .theme--dark .list-btn-bg-color{
    background-color: #2a2c35;
  }
  .theme--light .list-btn-bg-color{
    background-color: #FAFBFF;
  }
</style>